import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";
import ContractEnquiryForm from "./ContractEnquiryForm";
import { heroSlides } from "../../data/mockData";
import { scrollToSection } from "../../lib/scrollToSection";

const LandlordCleaningPage = () => {
  const pageData = {
    pageTitle: "Landlord & Letting Agent Cleaning Cardiff | Contract Cleaning | NeatWave",
    metaDescription: "Contract cleaning for landlords and letting agents in Cardiff. End of tenancy, mid-tenancy, pre-let and communal area cleaning for single lets, HMOs and student portfolios. Request a contract price.",

    heroTitle: "Landlord & Letting Agent Cleaning in Cardiff",
    heroSubtitle: "One reliable cleaning partner for your whole portfolio. End of tenancy, pre-let and communal cleaning, scheduled around your tenancy changes.",
    heroImage: heroSlides.find((s) => s.id === "end-of-tenancy").image,
    ctaLabel: "Request a Contract Price",
    onCta: () => scrollToSection("contract-enquiry"),

    serviceDescription: (
      <>
        <p className="mb-4">
          Managing tenancy changeovers is easier with one cleaning team you can rely on. NeatWave works with landlords, letting agents and property managers across Cardiff to keep properties clean, let-ready and inspection-ready.
        </p>
        <p className="mb-4">
          From single buy-to-lets to student HMO portfolios, we handle <strong>end of tenancy cleans, pre-let deep cleans, mid-tenancy inspection cleans and communal area cleaning</strong>, including ovens and carpets, all to an agency-standard checklist.
        </p>
        <p className="mb-4">
          Tell us how many properties you manage and how often you need us, and we'll prepare a tailored contract price. Our team is DBS-checked and fully insured.
        </p>
      </>
    ),

    whatIncluded: [
      { title: "End of Tenancy Cleans", description: "Deposit-ready cleans to an agency-standard checklist at every changeover" },
      { title: "Pre-let Deep Cleans", description: "Top-to-bottom cleans so new tenants move into a spotless property" },
      { title: "Mid-tenancy Inspections", description: "Cleans ahead of inspections, viewings or photography" },
      { title: "Communal Areas", description: "Scheduled cleaning of hallways, stairs and shared spaces" },
      { title: "Ovens & Carpets", description: "Oven cleaning and hot water extraction carpet cleaning added as needed" },
      { title: "One Point of Contact", description: "Simple booking for your whole portfolio, with key collection arranged" },
    ],

    pricingInfo: {
      duration: "Scheduled to suit you",
      price: "Contract price",
      note: "Contract prices depend on the number of properties, their size and how often you need us. Use the form below and we'll reply with a tailored price.",
    },

    faqs: [
      { q: "Do you work with letting agents and property managers?", a: "Yes. We work with landlords, letting agents and property managers, and can schedule cleans around each tenancy change across your portfolio." },
      { q: "Can you clean HMOs and student properties?", a: "Yes. We clean HMOs and student lets, including end of tenancy cleans when tenancies swap over, communal areas, ovens and carpets." },
      { q: "How is a contract price worked out?", a: "It depends on how many properties you have, their size, the services you need and how often. Send us your details using the form and we'll prepare a tailored price." },
    ],

    testimonial: {
      text: "We had Neatwave carry out all of our end of tenancy cleans when our student tenancies swapped over, they completed around 60 oven cleans for us and they were fab, very professional and reasonably priced, would definitely recommend.",
      author: "Charlie Redding, Pinnacle Property Management - Google review",
    },

    relatedServices: [
      { title: "End of Tenancy Cleaning", description: "Deposit-ready deep cleans for moving out", url: "/end-of-tenancy-cleaning-cardiff" },
      { title: "Carpet Cleaning", description: "Hot water extraction for stains and odours", url: "/carpet-cleaning-cardiff" },
      { title: "Oven Cleaning", description: "Professional oven and hob cleaning", url: "/oven-cleaning-cardiff" },
    ],

    extraSection: <ContractEnquiryForm />,
  };

  return <ServicePageTemplate {...pageData} />;
};

export default LandlordCleaningPage;
